import { FC } from 'react'
import {
  required,
  TextInput,
  useRecordContext,
  useGetList,
  SelectInput,
} from 'react-admin'

const CreateRequestForm: FC = () => {
  const record = useRecordContext()
  const { data: deelnemers, isLoading } = useGetList(`deelnemers/${record?.id}`)

  return (
    <>
      <TextInput
        source="formValues.titel"
        label={'data.request'}
        validate={required()}
      />
      <SelectInput
        source="formValues.ontvanger"
        label="data.receiver"
        choices={deelnemers ?? []}
        optionText="organisatie.naam"
        optionValue="id"
        isLoading={isLoading}
        validate={required()}
      />
      <TextInput
        source="formValues.omschrijving"
        label={'data.explanation'}
        validate={required()}
      />
      <TextInput
        source="formValues.productId"
        label={'data.productCode'}
      />
    </>
  )
}

export default CreateRequestForm
